import { createDirectus, readItems, rest, staticToken } from "@directus/sdk";

const priceUrl = process.env.REACT_APP_PRICE_DIRECTUS_URL;
const priceToken = process.env.REACT_APP_PRICE_DIRECTUS_TOKEN;

if (!priceUrl || !priceToken) {
  // Helps debugging env misconfiguration in local/staging.
  console.warn(
    "Price Directus env vars are missing: REACT_APP_PRICE_DIRECTUS_URL / REACT_APP_PRICE_DIRECTUS_TOKEN"
  );
}

const priceApi = createDirectus(priceUrl || "")
  .with(rest())
  .with(staticToken(priceToken || ""));

const req = (collection, query = {}) => {
  return priceApi.request(readItems(collection, query));
};

/** True when Directus price analytics env vars are both set (Overview / trend charts gate). */
export function priceDirectusConfigured() {
  return Boolean(priceUrl && priceToken);
}

export { priceApi, req };
